import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {IInvestmentOfferTileProps as IInvestmentOfferTileProps} from "../components/InvestmentOfferTile";
import {InvestmentOfferAreaSlug, InvestmentOfferCountrySlug, InvestmentOfferTypeSlug} from "../constants/investment_offer_constants";

const investmentOfferAreasAbroad = require("../images/areas/abroad.jpg");
const investmentOfferAreasSea = require("../images/areas/sea.jpg");
const investmentOfferAreasLake = require("../images/areas/lake.jpg");
const investmentOfferAreasMountain = require("../images/areas/mountain.jpg");

const getInvestmentOfferAreaHref = (
    subcategory: InvestmentOfferAreaSlug | InvestmentOfferCountrySlug,
    category: InvestmentOfferTypeSlug = InvestmentOfferTypeSlug.HOLIDAY
) => {
    return rpAppLink.investmentOffer.investmentCategory.subcategory.base({
        category,
        subcategory
    });
};

export const useInvestmentOfferAreas = (): Omit<IInvestmentOfferTileProps, "ratioVariant">[] => {
    const stats = useSelector((state: IRPStore) => state.investmentOffer.stats);

    return [
        {
            href: getInvestmentOfferAreaHref(InvestmentOfferCountrySlug.SPAIN, InvestmentOfferTypeSlug.ABROAD),
            offersCount: stats.abroad.spain,
            image: investmentOfferAreasAbroad,
            title: "Hiszpania",
            text: "Zainwestuj w ulubionych turystycznych destynacjach"
        },
        {
            href: getInvestmentOfferAreaHref(InvestmentOfferAreaSlug.SEA),
            offersCount: stats.totals.holiday_location_sea,
            image: investmentOfferAreasSea,
            title: "Nad morzem",
            text: "Zainwestuj i zarabiaj nad Bałykiem"
        },
        {
            href: getInvestmentOfferAreaHref(InvestmentOfferAreaSlug.LAKE),
            offersCount: stats.totals.holiday_location_lake,
            image: investmentOfferAreasLake,
            title: "Nad jeziorem",
            text: "Odpoczywaj w otoczeniu polskich jezior i pomnażaj kapitał"
        },
        {
            href: getInvestmentOfferAreaHref(InvestmentOfferAreaSlug.MOUNTAIN),
            offersCount: stats.totals.holiday_location_mountains,
            image: investmentOfferAreasMountain,
            title: "W górach",
            text: "Wypoczywaj i zarabiaj przez cały rok"
        }
    ];
};
import {useSelector} from "react-redux";

import {rpAppLink} from "@pg-mono/rp-routes";

import {IRPStore} from "../../app/rp_reducer";
import {IInvestmentOfferTileProps as IInvestmentOfferTileProps} from "../components/InvestmentOfferTile";
import {InvestmentOfferAreaSlug, InvestmentOfferCountrySlug, InvestmentOfferTypeSlug} from "../constants/investment_offer_constants";

const investmentOfferAreasAbroad = require("../images/areas/abroad.jpg");
const investmentOfferAreasSea = require("../images/areas/sea.jpg");
const investmentOfferAreasLake = require("../images/areas/lake.jpg");
const investmentOfferAreasMountain = require("../images/areas/mountain.jpg");

const getInvestmentOfferAreaHref = (
    subcategory: InvestmentOfferAreaSlug | InvestmentOfferCountrySlug,
    category: InvestmentOfferTypeSlug = InvestmentOfferTypeSlug.HOLIDAY
) => {
    return rpAppLink.investmentOffer.investmentCategory.subcategory.base({
        category,
        subcategory
    });
};

export const useInvestmentOfferAreas = (): Omit<IInvestmentOfferTileProps, "ratioVariant">[] => {
    const stats = useSelector((state: IRPStore) => state.investmentOffer.stats);

    return [
        {
            href: getInvestmentOfferAreaHref(InvestmentOfferCountrySlug.SPAIN, InvestmentOfferTypeSlug.ABROAD),
            offersCount: stats.abroad.spain,
            image: investmentOfferAreasAbroad,
            title: "Hiszpania",
            text: "Zainwestuj w ulubionych turystycznych destynacjach"
        },
        {
            href: getInvestmentOfferAreaHref(InvestmentOfferAreaSlug.SEA),
            offersCount: stats.totals.holiday_location_sea,
            image: investmentOfferAreasSea,
            title: "Nad morzem",
            text: "Zainwestuj i zarabiaj nad Bałykiem"
        },
        {
            href: getInvestmentOfferAreaHref(InvestmentOfferAreaSlug.LAKE),
            offersCount: stats.totals.holiday_location_lake,
            image: investmentOfferAreasLake,
            title: "Nad jeziorem",
            text: "Odpoczywaj w otoczeniu polskich jezior i pomnażaj kapitał"
        },
        {
            href: getInvestmentOfferAreaHref(InvestmentOfferAreaSlug.MOUNTAIN),
            offersCount: stats.totals.holiday_location_mountains,
            image: investmentOfferAreasMountain,
            title: "W górach",
            text: "Wypoczywaj i zarabiaj przez cały rok"
        }
    ];
};
